import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Loader2, Search, Building2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FirmCards from "@/components/FirmCards";
import { api } from "@/lib/api";

export default function Firms() {
  const [firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [districts, setDistricts] = useState({ SK: [], CZ: [] });
  const [district, setDistrict] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    document.title = "Overení realizátori zateplenia podľa okresov | Zateplenia.eu";
    let el = document.querySelector('meta[name="description"]');
    if (el) el.setAttribute("content", "Katalóg overených realizačných firiem na zateplenie fasád podľa okresu — kontakt, referencie a možnosť priameho dopytu.");
    api.get("/firms/public").then((r) => setFirms(r.data || [])).catch(() => setFirms([])).finally(() => setLoading(false));
    api.get("/firm/districts").then((r) => setDistricts(r.data)).catch(() => {});
  }, []);

  const list = firms.filter((f) => {
    if (district && f.district !== district) return false;
    if (q) { const s = `${f.company} ${f.district} ${f.city} ${f.bio}`.toLowerCase(); if (!s.includes(q.toLowerCase())) return false; }
    return true;
  });
  const allDistricts = [...(districts.SK || []), ...(districts.CZ || [])];

  return (
    <div className="bg-ink min-h-screen text-white" data-testid="firms-catalog-page">
      <Header />
      <section className="max-w-6xl mx-auto px-5 md:px-8 pt-28 md:pt-32 pb-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="flex items-center gap-2 text-gold text-xs font-mono2 uppercase tracking-[0.3em] mb-4"><Building2 className="w-4 h-4" /> Overení realizátori</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-3">Katalóg realizačných firiem</h1>
          <p className="text-white/50 text-base md:text-lg max-w-2xl">Preverené firmy na zateplenie a fasády vo vašom okrese. Pozrite si ich referencie a kontaktujte ich priamo — alebo si nechajte spočítať cenu a firmy sa ozvú vám.</p>
        </motion.div>

        <div className="flex flex-wrap gap-3 items-center mt-8 mb-8">
          <div className="relative">
            <Search className="w-4 h-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
            <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="firms-search" placeholder="Hľadať firmu…" className="bg-ink-2 border border-white/15 pl-9 pr-4 py-2.5 text-white text-sm focus:border-gold outline-none w-64" />
          </div>
          <select value={district} onChange={(e) => setDistrict(e.target.value)} data-testid="firms-district-filter" className="bg-ink-2 border border-white/15 px-3 py-2.5 text-white text-sm focus:border-gold outline-none">
            <option value="">Všetky okresy</option>
            {allDistricts.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
          <span className="text-white/40 text-sm">{list.length} firiem</span>
        </div>

        {loading ? (
          <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 text-gold animate-spin" /></div>
        ) : list.length ? (
          <FirmCards firms={list} />
        ) : (
          <div className="border border-white/10 bg-ink-2 p-12 text-center" data-testid="firms-empty">
            <Building2 className="w-10 h-10 text-white/20 mx-auto mb-4" />
            <p className="text-white/60 mb-2">Zatiaľ tu nie sú žiadne zverejnené vizitky{district ? ` v okrese ${district}` : ""}.</p>
            <p className="text-white/40 text-sm">Ste realizačná firma? <a href="/firma-portal" className="text-gold hover:underline">Registrujte sa a vytvorte si vizitku.</a></p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
